import React from "react";
import {
  Bar, DownloadIcon, IconsWrapper, Logo, LogoText, LogoWrapper, MessageIcon, SearchIcon,
} from "./Appbar.style";
import { useNavigate } from "react-router-dom";
import { PUBLIC_ROUTE } from "@router/route.constants";

const Appbar = () => {
  const navigate = useNavigate();
  const goToSearch = () => {
    navigate(`/${PUBLIC_ROUTE.SEARCH}`);
  }

  const goToDownload = () => {
    navigate(`/${PUBLIC_ROUTE.APP_DOWNLOAD}`);
  }

  const goToMessages = () => {
    navigate(`/${PUBLIC_ROUTE.MESSAGE}`);
  }

  return (
    <Bar>
      <LogoWrapper>
        <Logo />
        <LogoText>Panda Gaming</LogoText>
      </LogoWrapper>
      <IconsWrapper>
        <SearchIcon onClick={goToSearch} />
        <MessageIcon onClick={goToMessages} />
        <DownloadIcon onClick={goToDownload} />
      </IconsWrapper>
    </Bar>
  );
};

export default Appbar;
